/* tslint:disable */
/* eslint-disable */
/**
 * care-plan
 * care-plan
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UnscheduledCareEntry } from './UnscheduledCareEntry';
import {
    UnscheduledCareEntryFromJSON,
    UnscheduledCareEntryFromJSONTyped,
    UnscheduledCareEntryToJSON,
} from './UnscheduledCareEntry';

/**
 * 
 * @export
 * @interface RecordUnscheduledCare201Response
 */
export interface RecordUnscheduledCare201Response {
    /**
     * 
     * @type {UnscheduledCareEntry}
     * @memberof RecordUnscheduledCare201Response
     */
    data?: UnscheduledCareEntry;
}

/**
 * Check if a given object implements the RecordUnscheduledCare201Response interface.
 */
export function instanceOfRecordUnscheduledCare201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RecordUnscheduledCare201ResponseFromJSON(json: any): RecordUnscheduledCare201Response {
    return RecordUnscheduledCare201ResponseFromJSONTyped(json, false);
}

export function RecordUnscheduledCare201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordUnscheduledCare201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : UnscheduledCareEntryFromJSON(json['data']),
    };
}

export function RecordUnscheduledCare201ResponseToJSON(value?: RecordUnscheduledCare201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': UnscheduledCareEntryToJSON(value.data),
    };
}

